import type { RDMDProps } from '@readme/iso';

import React from 'react';

interface DehydratedProps {
  className?: string;
  string?: string;
  Tag?: RDMDProps['Tag'];
}

const Dehydrated = ({ className, string = '', Tag = 'div' }: DehydratedProps) => (
  <Tag className={className} dangerouslySetInnerHTML={{ __html: string }} />
);

export default Dehydrated;
